export default {"src":"/_next/static/media/icon_non-profit_model.e0870f97.svg","height":35,"width":35,"blurWidth":0,"blurHeight":0};